import React from "react";
import { Box, Button, Card, Stack, Typography } from "@mui/material";

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionIcon?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, actionLabel, onAction, actionIcon }) => (
  <Card elevation={0} sx={{ borderRadius: 3, border: "1px dashed", borderColor: "divider" }}>
    <Stack sx={{ alignItems: "center", textAlign: "center", py: "40px", px: "24px", gap: "6px" }}>
      <Box sx={{ color: "text.disabled", "& svg": { fontSize: 40 } }}>{icon}</Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{title}</Typography>
      {description && <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>{description}</Typography>}
      {actionLabel && onAction && (
        <Button variant="contained" startIcon={actionIcon} onClick={onAction} sx={{ mt: "12px" }}>
          {actionLabel}
        </Button>
      )}
    </Stack>
  </Card>
);

export default EmptyState;
